import { Link } from "react-router-dom";

function Landing() {
  const glass = {
    background: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(10px)",
    borderRadius: "15px",
    padding: "30px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
    width: "400px",
    textAlign: "center",
  };

  return (
    <div
      style={{
        height: "100vh",
        background: "linear-gradient(135deg, #1e1e2f, #2a2a40)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* 🔥 GLASS CARD */}
      <div style={glass}>
        <h1 style={{ fontSize: "40px" }}>PrepGrid 🚀</h1>

        <p style={{ margin: "15px 0" }}>
          Crack FAANG interviews with AI-powered practice 💻🤖
        </p>

        <div>
          <Link to="/login">
            <button style={btn1}>Get Started</button>
          </Link>

          <Link to="/register">
            <button style={btn2}>Create Account</button>
          </Link>
        </div>
      </div>
    </div>
  );
}

const btn1 = {
  padding: "12px 20px",
  margin: "10px",
  background: "#00c6ff",
  border: "none",
  borderRadius: "8px",
  color: "white",
  fontWeight: "bold",
  cursor: "pointer",
};

const btn2 = {
  padding: "12px 20px",
  margin: "10px",
  background: "transparent",
  border: "2px solid white",
  color: "white",
  borderRadius: "8px",
  cursor: "pointer",
};

export default Landing;